<div>
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Current Learners">
    </mat-tab>
    <mat-tab label="Historic Learners">
    </mat-tab>
  </mat-tab-group>
</div>
<mat-card id='view-programmes'>
  <br>



    @if (cLearner === true) {
      <mat-card-header>
        <span class="search-container example-form">
          <mat-form-field id="search_service_user_form" class="input-width " appearance="fill">
            <mat-label>Search by</mat-label>
            <input id="search_service_user_input" autocomplete="off" (keydown.enter)="onFilter(search_service_user_input.value)" matInput
              #search_service_user_input aria-label="Search a user">
              <button type="button" id="do_search_button" mat-icon-button matSuffix aria-label="Search"
                (click)="onFilter(search_service_user_input.value)">
                <mat-icon>search</mat-icon>
              </button>
              @if (search_service_user_input.value !=='') {
                <button type="button" id="clear_search_button" mat-icon-button matSuffix
                  aria-label="Clear" (click)="onFilter(''); search_service_user_input.value=''">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </span>
          <span class="spacer"></span>
        </mat-card-header>
      }

      @if (cLearner === false) {
        <mat-card-header>
          <span class="example-form">
            <mat-form-field id="search_service_user_form" class="example-full-width" appearance="fill">
              <mat-label>Search by</mat-label>
              <input id="search_service_user_input" autocomplete="off" (keydown.enter)="onFilter(search_service_user_input.value)" matInput
                #search_service_user_input aria-label="Search a user">
                <button type="button" id="do_search_button" matSuffix mat-icon-button aria-label="Search"
                  (click)="onFilter(search_service_user_input.value)">
                  <mat-icon>search</mat-icon>
                </button>
                @if (search_service_user_input.value !=='') {
                  <button type="button" id="clear_search_button" mat-icon-button matSuffix
                    aria-label="Clear" (click)="onFilter(''); search_service_user_input.value=''">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </span>
            <span class="spacer"></span>
          </mat-card-header>
        }

        <mat-card-content class="learners">

          <span class="spacer"></span>


          <mat-table id="learners_table" #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="DateofBirth">
              <mat-header-cell *matHeaderCellDef id="DateofBirth">
                PRN
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">PRN:</span>
                {{ element.prn || 'N/A' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <mat-header-cell *matHeaderCellDef id="firstName" mat-sort-header>
                First name
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">First name:</span>
                {{ element.firstName || 'N/A'  }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="lastName" >
              <mat-header-cell *matHeaderCellDef id="lastName" mat-sort-header>
                Last name
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Last name:</span>
                {{ element.lastName || 'N/A'  }}
              </mat-cell>
            </ng-container>

            @if (!cLearner) {
              <ng-container matColumnDef="establishmentId">
                <mat-header-cell *matHeaderCellDef id="establishmentId">
                  Current location
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">Current Location</span>
                  {{ element.organizationName || 'N/A' }}
                </mat-cell>
              </ng-container>
            }


            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let element">

                <button id="view_user_button_{{element.id}}" mat-icon-button color="primary"
                  matTooltip="View" [matTooltipShowDelay]="800" class="ml-6"
                  [routerLink]="['./view']" [queryParams]="{id: element.id ,cLearner: cLearner, fname:element.firstName+' '+ element.lastName}">
                  <mat-icon>visibility</mat-icon>
                </button>



              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="cLearner ? displayedColumns : displayedHistoricColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: cLearner ? displayedColumns : displayedHistoricColumns;"></mat-row>
          </mat-table>
          <mat-paginator id="user_pagination" [pageSize]="pageSize" [showFirstLastButtons]='true' [hidePageSize]="true">
          </mat-paginator>
        </mat-card-content>
      </mat-card>

